var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-24 flex justify-center bg-white"},[_c('div',{staticClass:"w-auto flex justify-center flex-wrap"},[_c('img',{staticClass:"mr-1",attrs:{"src":require("@/assets/images/accounting/no-file.svg")}}),_c('p',{staticClass:"w-full py-4"},[_vm._v("Imported data will appear here...")])])])
}]

export { render, staticRenderFns }